// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1dAtK{height:auto;padding:1.6rem .8rem;width:auto}", ""]);
// Exports
exports.locals = {
	"bottomNavIcon": "_1dAtK"
};
module.exports = exports;
